import { all, call, put, takeLatest } from 'redux-saga/effects'
import CreditActions, { CreditTypes } from 'Redux/CreditRedux'

// Fetch credit balance
export function* fetchCredits(api, action) {
  try {
    const { callback } = action
    const resp = yield call(api.getCredits)

    if (resp.ok) {
      yield put(CreditActions.creditsFetchSuccess(resp.data.credits, resp.data.costs))
      if (callback) {
        callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to fetch credits'
      yield put(CreditActions.creditsFetchFailure(error))
      if (callback) {
        callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to fetch credits'
    yield put(CreditActions.creditsFetchFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Preview cost before action
export function* previewCredits(api, action) {
  try {
    const { scenesCount, animate, callback } = action
    const resp = yield call(api.previewCredits, { scenes_count: scenesCount, animate })

    if (resp.ok) {
      yield put(CreditActions.creditsPreviewSuccess(resp.data))
      if (callback) {
        callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to preview credits'
      yield put(CreditActions.creditsPreviewFailure(error))
      if (callback) {
        callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to preview credits'
    yield put(CreditActions.creditsPreviewFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Check if action is affordable
export function* checkCredits(api, action) {
  try {
    const { actionType, count, callback } = action
    const resp = yield call(api.checkCredits, { action_type: actionType, count })

    if (resp.ok) {
      yield put(CreditActions.creditsCheckSuccess(
        resp.data.can_afford,
        resp.data.required_credits,
        resp.data.available_credits
      ))
      if (callback) {
        callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to check credits'
      yield put(CreditActions.creditsCheckFailure(error))
      if (callback) {
        callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to check credits'
    yield put(CreditActions.creditsCheckFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Fetch credit history
export function* fetchCreditHistory(api, action) {
  try {
    const { params, callback } = action
    const resp = yield call(api.getCreditHistory, params)

    if (resp.ok) {
      yield put(CreditActions.creditsHistorySuccess(resp.data.history, resp.data.total_count))
      if (callback) {
        callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to fetch credit history'
      yield put(CreditActions.creditsHistoryFailure(error))
      if (callback) {
        callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to fetch credit history'
    yield put(CreditActions.creditsHistoryFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Watcher saga
export default function* creditSaga(api) {
  yield all([
    takeLatest(CreditTypes.CREDITS_FETCH_REQUEST, fetchCredits, api),
    takeLatest(CreditTypes.CREDITS_PREVIEW_REQUEST, previewCredits, api),
    takeLatest(CreditTypes.CREDITS_CHECK_REQUEST, checkCredits, api),
    takeLatest(CreditTypes.CREDITS_HISTORY_REQUEST, fetchCreditHistory, api),
  ])
}
